'use strict';

angular.module('cgmemApp')
	.controller('FrontDeskNoticeCtrl', function ($rootScope, $log, $uibModal, Notice, CheckIn) {

		this.ns = Notice.get();
		this.activeCheckIns = CheckIn.getActive();

		this.activePoolNotice = () => _.find(this.ns, { collapseKey: 'pool' });
		this.generalNotice = n => (!n.collapseKey || !n.collapseKey.length);

		var modals = {
			setClose: {
				templateUrl: 'closePool.html',
				controller: 'closePoolCtrl'
			},
			setOpen: {
				templateUrl: 'openPool.html',
				controller: 'openPoolCtrl'
			},
			general: {
				templateUrl: 'generalNotice.html',
				controller: 'generalNoticeCtrl'
			},
			generalDel: {
				templateUrl: 'generalNoticeDel.html',
				controller: 'generalNoticeDelCtrl'
			}
		}

		this.openNoticeModal = (modalKey, notice) => {
			$uibModal.open(
				_.extend({
					controllerAs: 'vm',
					resolve: {
						existingNotice: () => notice
					}
				}, modals[modalKey]))
				.result
				.then(n => Notice.upsertNotice(n))
				.catch(err => { });
		}
	})
	.controller('closePoolCtrl', function ($uibModalInstance, $log, existingNotice) {
		this.data = Object.assign({}, existingNotice ? existingNotice.data : { reason: "thunder" });
		this.update = existingNotice && existingNotice.data;
		this.ok = () => {
			var newNotice = {
				collapseKey: 'pool',
				expires: (new Date()).setHours(23, 59, 59, 999),
				title: "Pool Closed",
				text: "Pool closed due to " + (this.data.reason == "thunder" ? "thunder" : this.data.otherReason) + ". " +
					"Opening no earlier than " +
					(this.data.reason == "thunder" ? moment().add(30, 'm').format('h:mm a') : this.data.earliestReopening) +
					".",
				priority: 1,
				private: false,
				data: this.data,
				updateOf: existingNotice && existingNotice._id,
				notify: true,
				// allow supression of thunder notices if one posted recently
				notificationThrottlable: existingNotice && this.data.reason == 'thunder' && existingNotice.data.reason == 'thunder'
			}
			$uibModalInstance.close(newNotice);
		};

		this.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};
	})
	.controller('openPoolCtrl', function ($uibModalInstance) {
		this.ok = function () {
			var notice = {
				collapseKey: 'pool',
				expires: 0,		// already expired
				title: "Pool Open",
				text: "Pool reopened at " + moment().format('h:mm a'),
				priority: 1,
				private: false,
				notify: true
			}
			$uibModalInstance.close(notice);
		};

		this.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};
	})
	.controller('generalNoticeCtrl', function ($uibModalInstance, $log, existingNotice) {
		var self = this;
		self.popupOpened = false;
		self.notice = existingNotice || { html: "", text: "", private: false, priority: 0, notify: false };
		self.notice.expires = new Date();

		self.dateOptions = {
			formatYear: 'yyyy',
			startingDay: 0,
			showWeeks: false
		};

		self.ok = function () {
			self.notice.expires = (new Date(self.notice.expires)).setHours(23, 59, 59, 999);
			$uibModalInstance.close(self.notice);
		};

		self.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};
	})
	.controller('generalNoticeDelCtrl', function ($uibModalInstance, existingNotice) {
		var self = this;
		self.notice = existingNotice;

		self.ok = function () {
			self.notice.expires = 0; self.notice.notify = false;
			$uibModalInstance.close(self.notice);
		};

		self.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};
	});




